export const PIX_SALES_TABS = [
  { id: "charges", labelKey: "pix.charges.tab" },
  { id: "payments", label: "Pagamentos", filterTable: "pixPayment", apiContext: "pixPayments" },
  { id: "received", label: "Recebimentos", filterTable: "pixReceive", apiContext: "pixReceive" },
];

export const PIX_STATUS_META = {
  paid: { label: "Pago", className: "bg-emerald-50 text-emerald-700" },
  pending: { label: "Pendente", className: "bg-blue-50 text-blue-700" },
  processing: { label: "Processando", className: "bg-blue-50 text-blue-700" },
  refused: { label: "Recusado", className: "bg-gray-100 text-gray-600" },
  rejected: { label: "Rejeitado", className: "bg-red-50 text-red-700" },
  canceled: { label: "Cancelado", className: "bg-red-50 text-red-700" },
  refunded: { label: "Ressarcido", className: "bg-violet-50 text-violet-700" },
  expired: { label: "Expirado", className: "bg-gray-100 text-gray-600" },
};

export const getPixStatusMeta = (status) =>
  PIX_STATUS_META[status] ?? { label: status || "—", className: "bg-gray-100 text-gray-600" };
